import './style.scss'
import { useState } from 'react';
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, ScreenContainer } from 'src/style';
import { SearchedFlights, TravelerSelection } from 'src/component'
import { FiChevronDown, FiChevronLeft } from 'react-icons/fi';
import { IoAirplaneOutline } from 'react-icons/io5';


export const Flights: React.FC<any> = ({back}) => {
    const [input, setInput] = useState({departureAirport: '', destinationAirport: '', flightDate: '', traveler: '', class: ''})
    const [navPosition, setNavPosition] = useState(0)
    const [view, setView] = useState('')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('searched-flights')
    }

    return (
        <>
            <ScreenContainer padding='2.5' topPadding='0'>
                <CustomContainer
                    customRadius='28px 28px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                >
                    <FlexRow>
                        <AppSpan 
                            textSize='2.5' hoverColor='#0D968F' rightMargin='2' topMargin='-0.5'
                            onClick={back}
                        >
                            <FiChevronLeft/>
                        </AppSpan>
                        <AppSpan textSize='2.2' fontWeight='700'>Flights</AppSpan>
                    </FlexRow>
                    <GridContainer 
                        height="3.6" topMargin="2" width='29.3' bottomMargin='2'
                        className='flight-toggle-container'
                    >
                        <AbsoluteContainer 
                            width='9.1'
                            top="0" left={`${navPosition}`}
                            className='flight-toggler'
                        >
                            <CustomContainer bgColor="#E7F6F5" height="3.6" radius="0.6" />
                        </AbsoluteContainer>
                        <FlexRow zIndex="2">
                            <GridContainer 
                                width='9.1' rightMargin='1' radius="0.6" hoverBgColor='#E7F6F5'
                                onClick={() => setNavPosition(0)}
                                className='flight-toggle-item'
                            >
                                <AppSpan 
                                    fontWeight='600' cursor="pointer"
                                    color={navPosition === 0 ? "#0A756F" : "#667085"}
                                >
                                    One Way
                                </AppSpan>
                            </GridContainer>
                            <GridContainer 
                                width='9.1' rightMargin='1' radius="0.6" hoverBgColor='#E7F6F5'
                                onClick={() => setNavPosition(10.1)}
                                className='flight-toggle-item'
                            >
                                <AppSpan 
                                    fontWeight='600' cursor="pointer"
                                    color={navPosition === 10.1 ? "#0A756F" : "#667085"}
                                >
                                    Return
                                </AppSpan>
                            </GridContainer>
                            <GridContainer 
                                width='9.1' radius="0.6" hoverBgColor='#E7F6F5'
                                onClick={() => setNavPosition(20.2)}
                                className='flight-toggle-item'
                            >
                                <AppSpan 
                                    fontWeight='600' cursor="pointer"
                                    color={navPosition === 20.2 ? "#0A756F" : "#667085"}
                                >
                                    Multi City
                                </AppSpan>
                            </GridContainer>
                        </FlexRow>
                    </GridContainer>
                    { navPosition === 0 &&
                        <CustomContainer>
                            <Form onSubmit={handleProceed}>
                                <FlexRow gap='2' gapUnit='%' wrap='wrap'>
                                    <FormGroupWithIcon width='23' className='flight-inputs'>
                                        <label>Departure Airport</label>
                                        <div className="input-with-icon">
                                            <IoAirplaneOutline style={{fontSize: '2rem', color: '#667085'}} className='input-left-icon'/>
                                            <input
                                                name='departureAirport'
                                                placeholder='Enter Departure'
                                                onChange={handleInput}
                                                value={input.departureAirport}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </FormGroupWithIcon>
                                    <FormGroupWithIcon width='23' className='flight-inputs'>
                                        <label>Destination Airport</label>
                                        <div className="input-with-icon">
                                            <IoAirplaneOutline style={{fontSize: '2rem', color: '#667085'}} className='input-left-icon'/>
                                            <input
                                                name='destinationAirport'
                                                placeholder='Enter Destination'
                                                value={input.destinationAirport}
                                                onChange={handleInput}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </FormGroupWithIcon>
                                    <FormGroup width='23' className='flight-inputs'>
                                        <label>Flight Date</label>
                                        <input 
                                            placeholder='dd/mm/yyyy' 
                                            type='date'
                                            name='flightDate'
                                            style={{color: input.flightDate ? '#000000' : '#667085'}}
                                            value={input.flightDate}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            //required
                                        />
                                    </FormGroup>
                                    <FormGroupWithIcon width='23' className='flight-inputs'>
                                        <label>Traveler</label>
                                        <div className="input-with-icon" onClick={() => setView('traveler-selection')}>
                                            <GridContainer leftPadding='1.5' rightPadding='3.5' height='100' hUnit='%'>
                                                <AppText textSize='1.6' width='100' sizeUnit='%' color={input.traveler ? '#000000' : '#667085'}>
                                                    {input.traveler || 'Select Traveler'}
                                                </AppText>
                                            </GridContainer>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon>
                                    <FormGroupWithIcon width='23' className='flight-inputs'>
                                        <label>Class</label>
                                        <div className="input-with-icon">
                                            <select 
                                                name='class'
                                                value={input.class}
                                                style={{color: input.class ? '#000000' : '#667085'}}
                                                onChange={handleInput}
                                                //required
                                            >
                                                <option value="">Select Class</option>
                                                <option value="Economy">Economy</option>
                                                <option value="VIP">VIP</option>
                                            </select>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon>
                                    <FlexRow width='23' sizeUnit='%' className='flight-inputs flight-search-btn'>
                                        <Button 
                                            width='12' height='4' topMargin='1' 
                                            borderColor='#0D968F' hoverBgColor='#fff' 
                                            hoverColor='#0D968F' titleSize='1.4'
                                            className='flight-search-btn'
                                        >
                                            Search Flight
                                        </Button>
                                    </FlexRow>
                                </FlexRow>
                            </Form>
                        </CustomContainer>
                    }
                </CustomContainer>
            </ScreenContainer>
            { view === 'traveler-selection' &&
                <TravelerSelection
                    close={() => setView('')}
                />
            }
            { view === 'searched-flights' &&
                <SearchedFlights
                    close={() => setView('')}
                />
            }
        </>
    );
}
